module.exports = __webpack_public_path__ + "img/wifi.36de5236.svg";